import { render, staticRenderFns } from "./ConfiguracaoIncisosEdicao.vue?vue&type=template&id=6cfaf908&scoped=true"
import script from "./ConfiguracaoIncisosEdicao.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoIncisosEdicao.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracaoIncisosEdicao.vue?vue&type=style&index=0&id=6cfaf908&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfaf908",
  null
  
)

export default component.exports